module.exports = __webpack_public_path__ + "static/img/product-swipe40.03c3ccfa.png";